import { forwardRef, type ButtonHTMLAttributes } from "react";

type Variant = "primary" | "secondary" | "outline" | "ghost";

interface FButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: Variant;
  fullWidth?: boolean;
  loading?: boolean;
}

const base =
  "inline-flex items-center justify-center gap-2 min-h-[44px] px-5 text-[15px] font-semibold transition-colors disabled:opacity-50 disabled:cursor-not-allowed";

const variants: Record<Variant, string> = {
  primary:
    "bg-[var(--colour-accent)] text-[var(--colour-text-inverse)] hover:opacity-95 active:opacity-90",
  secondary:
    "bg-[var(--colour-primary)] text-[var(--colour-text-inverse)] hover:opacity-95",
  outline:
    "bg-[var(--colour-surface)] text-[var(--colour-text-primary)] border border-[var(--colour-border)] hover:bg-[var(--colour-surface-raised)]",
  ghost: "bg-transparent text-[var(--colour-text-primary)] hover:bg-[var(--colour-surface-raised)]",
};

export const FButton = forwardRef<HTMLButtonElement, FButtonProps>(function FButton(
  { className = "", variant = "primary", fullWidth, loading, children, disabled, ...rest },
  ref,
) {
  return (
    <button
      ref={ref}
      disabled={disabled || loading}
      className={[
        base,
        variants[variant],
        fullWidth ? "w-full" : "",
        "rounded-[var(--radius-sm)]",
        className,
      ].join(" ")}
      {...rest}
    >
      {loading ? "…" : children}
    </button>
  );
});
